import _ from 'lodash';
import { Box } from '@mui/material';
import { Fragment } from 'react';
import { RootState } from '../../redux/store';
import { useSelector } from 'react-redux';
import HomeOutlinedIcon from '@mui/icons-material/HomeOutlined';
import MapsHomeWorkOutlinedIcon from '@mui/icons-material/MapsHomeWorkOutlined';
import LocationOnOutlinedIcon from '@mui/icons-material/LocationOnOutlined';
import AccountCircleOutlinedIcon from '@mui/icons-material/AccountCircleOutlined';
import HelpOutlineOutlinedIcon from '@mui/icons-material/HelpOutlineOutlined';
import WorkOutlineOutlinedIcon from '@mui/icons-material/WorkOutlineOutlined';
import TextSnippetOutlinedIcon from '@mui/icons-material/TextSnippetOutlined';
import BadgeOutlinedIcon from '@mui/icons-material/BadgeOutlined';
import DescriptionOutlinedIcon from '@mui/icons-material/DescriptionOutlined';
import EmojiTransportationOutlinedIcon from '@mui/icons-material/EmojiTransportationOutlined';
import ManageAccountsOutlinedIcon from '@mui/icons-material/ManageAccountsOutlined';
import PeopleOutlinedIcon from '@mui/icons-material/PeopleOutlined';
import RequestQuoteOutlinedIcon from '@mui/icons-material/RequestQuoteOutlined';

import MenuAccessItem from './components/MenuAccesItem';
import styles from './styles.menu.module.css';
import { useLocation } from 'react-router-dom';
import { useRoles } from '../../hooks/useRoles';
import {
    ArticlePersonIcon,
    AvisoObraIcon,
    DownloadFileIcon,
    ReconfirmacionIcon,
    ResultsIcon,
    SiniestroRoamIcon,
    ShieldWithHeartIcon,
    ZonePersonUrgentIcon
} from '../Icons';

interface MenuProps {
    sideMenu?: boolean | undefined;
    handleDrawerToggle?: () => void;
    open?: boolean;
}

const HARCODED_HOME_ITEM = {
    id: 0,
    nombre: 'Inicio',
    funcionalidades: [
        {
            id: 15,
            nombre: 'home',
            urlRedireccion: '/home',
            visualizarMenu: true
        }
    ],
    orden: 4
};

const HARCODED_HELP_CENTER_ITEM = {
    id: 18,
    nombre: 'Centro de ayuda',
    funcionalidades: [
        {
            id: 15,
            nombre: 'Centro de ayuda',
            urlRedireccion: '/centro-de-ayuda',
            visualizarMenu: true
        }
    ],
    orden: 18
};

const HARDCODED_VISITAS_ROAM_ITEM = {
    id: 89,
    nombre: 'Visitas ROAM',
    funcionalidades: [
        {
            id: 89,
            nombre: 'Visitas ROAM',
            urlRedireccion: '/visitas-roam',
            visualizarMenu: true
        }
    ],
    orden: 17
};

export const getIcon = (id: number, isSupervisorSIMP: boolean) => {
    const icons: { [key: number]: any } = {
        0: <HomeOutlinedIcon />,
        1: <AccountCircleOutlinedIcon />,
        2: <AccountCircleOutlinedIcon />,
        3: <LocationOnOutlinedIcon />,
        4: isSupervisorSIMP ? null : <TextSnippetOutlinedIcon />,
        7: <MapsHomeWorkOutlinedIcon />,
        5: <BadgeOutlinedIcon />,
        6: <WorkOutlineOutlinedIcon />,
        8: <DownloadFileIcon />,
        10: <EmojiTransportationOutlinedIcon />,
        11: <ShieldWithHeartIcon />,
        13: <AvisoObraIcon />,
        14: <DescriptionOutlinedIcon />,
        15: <ManageAccountsOutlinedIcon />,
        16: <SiniestroRoamIcon />,
        17: <RequestQuoteOutlinedIcon />,
        18: <HelpOutlineOutlinedIcon />,
        55: <ZonePersonUrgentIcon />,
        56: <ArticlePersonIcon />,
        69: <ReconfirmacionIcon />,
        70: <ResultsIcon />,
        84: <SiniestroRoamIcon />,
        85: <SiniestroRoamIcon />,
        86: <SiniestroRoamIcon />,
        87: <SiniestroRoamIcon />,
        88: <SiniestroRoamIcon />,
        89: <SiniestroRoamIcon />,
        90: <PeopleOutlinedIcon />
    };
    return icons[id] || null;
};

function MenuComponent({ sideMenu, handleDrawerToggle, open }: MenuProps) {
    const { isViewerBO, isPreventor, isProvider, isAuditorFacturacion } = useRoles();
    const location = useLocation();
    const userFunctionalities = useSelector(
        (state: RootState) => state.auth?.user?.funcionalidadesAgrupadas
    );

    const isActive = (item: any) => {
        const normalizedPath = location.pathname.replace(/\/$/, '');

        return item?.funcionalidades?.some((func: any) => {
            if (!func.visualizarMenu) return false;

            const normalizedRedirection = (
                func.urlRedireccion.startsWith('/')
                    ? func.urlRedireccion
                    : '/' + func.urlRedireccion
            ).replace(/\/$/, '');

            if (
                normalizedPath === '/usuarios/perfil' &&
                normalizedRedirection.includes('/usuarios')
            ) {
                return false;
            }

            if (
                location.state?.fromVisitasRoam &&
                normalizedRedirection.includes('/visitas') &&
                !normalizedRedirection.includes('/visitas-roam')
            ) {
                return false;
            }

            return (
                normalizedPath.endsWith(normalizedRedirection) ||
                normalizedPath.includes(normalizedRedirection + '/')
            );
        });
    };

    return (
        <Box
            justifyContent={'space-between'}
            display={'flex'}
            flexDirection={'column'}
            height={'100%'}
        >
            <Box className={styles[`menucomponent-container${sideMenu ? '-side' : ''}`]}>
                {/* El rol de auditoría de facturación no tiene home: entra directo a su pantalla. */}
                {!isProvider && !isAuditorFacturacion && (
                    <Fragment key={1000}>
                        <MenuAccessItem
                            item={HARCODED_HOME_ITEM}
                            sideMenu={sideMenu}
                            open={open}
                            handleDrawerToggle={handleDrawerToggle}
                            active={isActive(HARCODED_HOME_ITEM)}
                        />
                    </Fragment>
                )}
                {userFunctionalities
                    ?.slice()
                    .filter(
                        (item: any) =>
                            !isProvider ||
                            !item?.funcionalidades?.some((func: any) => {
                                const url = func?.urlRedireccion?.toLowerCase() || '';
                                return url.includes('proveedores');
                            })
                    )
                    .sort((a: any, b: any) => a.orden - b.orden)
                    .map((item: any, index: any) => (
                        <Fragment key={index}>
                            <MenuAccessItem
                                item={item}
                                sideMenu={sideMenu}
                                open={open}
                                handleDrawerToggle={handleDrawerToggle}
                                active={isActive(item)}
                            />
                        </Fragment>
                    ))}
                {isPreventor && (
                    <MenuAccessItem
                        item={HARDCODED_VISITAS_ROAM_ITEM}
                        sideMenu={sideMenu}
                        open={open}
                        handleDrawerToggle={handleDrawerToggle}
                        active={isActive(HARDCODED_VISITAS_ROAM_ITEM) || Boolean(location.state?.fromVisitasRoam)}
                    />
                )}
            </Box>

            <Box className={styles[`menucomponent-container${sideMenu ? '-side' : ''}`]}>
                {!isViewerBO && !isProvider && !isAuditorFacturacion && (
                    <MenuAccessItem
                        item={HARCODED_HELP_CENTER_ITEM}
                        sideMenu={sideMenu}
                        open={open}
                        handleDrawerToggle={handleDrawerToggle}
                        active={isActive(HARCODED_HELP_CENTER_ITEM)}
                    />
                )}
            </Box>
        </Box>
    );
}

export default MenuComponent;
